angular.module('impactx.togglebutton').directive('ixToggleButton', function ($parse) {
    return {
        restrict: 'E',
        require: '^^ngModel',
        transclude: true,
        scope: {},
        controller: function ($scope) {
            this.selectEntry = function () {
                if ($scope.ngModelCtrl) {
                    $scope.ngModelCtrl.$setViewValue($scope.value);
                }
            }
        },
        controllerAs: 'ctrl',
        templateUrl: 'shared/togglebutton/templates/toggle-button.tmpl.html',
        link: function (scope, element, attr, ngModelCtrl) {
            scope.ngModelCtrl = ngModelCtrl;
            scope.value = $parse(attr.value)(scope);
            scope.clazz = attr.clazz;
        }
    }
});